import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import {
  AIButtonIconGradientDef,
  AIButtonIconGradientSvgPlacement,
  getAIButtonIconGradientStyleVars,
  useAIButtonIconGradientId,
} from '../../../../AIButton'
import { ICON_COLOR, ICON_HEIGHT_20, IconNG } from '../../../../Icon'
import { Status, STATUS_SIZE_20 } from '../../../../Status'
import Text from '../../../../Text'
import { GRETA_AI_CHAT_SOURCE_TEXT_KEYS } from '../../../GretaAIChat.constants'

import {
  GRETA_AI_CHAT_SOURCE_ICON,
  GRETA_AI_CHAT_SOURCE_PICKER_GRADIENT_ID_PREFIX,
} from './GretaAIChatSourcePickerCardLabel.constants'

import * as styles from './GretaAIChatSourcePickerCardLabel.module.css'

function GretaAIChatSourcePickerCardLabel({
  isNew = false,
  isSelected = false,
  source,
}) {
  const { t } = useTranslation()

  const gradientId = useAIButtonIconGradientId(
    GRETA_AI_CHAT_SOURCE_PICKER_GRADIENT_ID_PREFIX
  )

  const { descriptionKey, nameKey } = GRETA_AI_CHAT_SOURCE_TEXT_KEYS[source]

  return (
    <>
      <span
        aria-hidden
        className={classNames(styles.iconTile, {
          [styles.selected]: isSelected,
        })}
        style={getAIButtonIconGradientStyleVars(gradientId)}
      >
        <AIButtonIconGradientDef
          gradientId={gradientId}
          placement={AIButtonIconGradientSvgPlacement.Embedded}
        />
        <IconNG
          Icon={GRETA_AI_CHAT_SOURCE_ICON[source]}
          color={ICON_COLOR.AiPrimary}
          size={ICON_HEIGHT_20}
        />
      </span>
      {isNew ? (
        <Status
          className={styles.newBadge}
          height={STATUS_SIZE_20}
          showTooltip={false}
          text={t('Greta.SourceNewBadgeKey')}
        />
      ) : null}
      <span className={styles.text}>
        <Text className={styles.title}>{t(nameKey)}</Text>
        <Text isSecondary className={styles.description}>
          {t(descriptionKey)}
        </Text>
      </span>
    </>
  )
}

export default GretaAIChatSourcePickerCardLabel
